import { canonicalPeriod } from "@chro/shared";

/** Keep suggestions descriptive for a uniform selection and neutral for mixed trades. */
export function suggestPairName(trades: { product: string; period: string }[], labels: string[]): string {
  const products = new Set(trades.map(trade => trade.product.trim()).filter(Boolean));
  const periods = new Set(trades.map(trade => canonicalPeriod(trade.period)).filter(Boolean));
  const base = [products.size === 1 ? [...products][0] : "Mixed products", periods.size === 1 ? [...periods][0] : "Mixed periods", "pair"].join(" · ").slice(0, 80);
  const existing = new Set(labels.map(label => label.toLowerCase()));
  let name = base;
  for (let index = 2; existing.has(name.toLowerCase()); index++) {
    const suffix = ` (${index})`;
    name = base.slice(0, 80 - suffix.length) + suffix;
  }
  return name;
}
